import {
	preliminaryOperatorCalculationConstants
}from './constants'
import actions from '../../actions'

const initialState =
{
	isSending  : false,
	paged      : null,
	list       : null,
	changed    : null,
	pagedAudit : null,
	countAudit : null
}

export default function (state = initialState, action){
	switch (action.type){
		case preliminaryOperatorCalculationConstants.GetPaged.REQUEST:
		case preliminaryOperatorCalculationConstants.Create.REQUEST:
		case preliminaryOperatorCalculationConstants.Delete.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case preliminaryOperatorCalculationConstants.GetPaged.FAILURE:
		case preliminaryOperatorCalculationConstants.Create.FAILURE:
		case preliminaryOperatorCalculationConstants.Delete.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case preliminaryOperatorCalculationConstants.GetPaged.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}

		case preliminaryOperatorCalculationConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case preliminaryOperatorCalculationConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case preliminaryOperatorCalculationConstants.CLEAR:
			return {
				...state,
				changed    : null,
				isSending  : false,
				paged      : null,
				list       : null,
				pagedAudit : null,
				countAudit : null
			}
		default:
			return state
	}
}